import React from "react";
import { ConfigProvider, Empty, Skeleton, Table } from "antd";

import classes from './AnnouncementsModal.module.scss'

import DynamicFilledButton from "../../../UI/DynamicFilledButton/DynamicFilledButton";
import UnderlinedLink from "../../../UI/UnderlinedLink/UnderlinedLink";
import MobileTableItem from "../../../UI/MobileTableItem/MobileTableItem";

const AnnouncementsModal = ({ announcements, loadingAnnouncements, scheduleType }) => {
    const sortByDates = (a, b) => {
        const tmpA = a.split(".")
        const tmpB = b.split(".")
        const firstDate = new Date(+tmpA[2], tmpA[1] - 1, +tmpA[0])
        const secondDate = new Date(+tmpB[2], tmpB[1] - 1, +tmpB[0])

        return firstDate.getTime() - secondDate.getTime()
    }

    const columns = [
        {
            title: 'Дата',
            dataIndex: 'date',
            align: 'center',
            width: 100,
            render: item => <div>
                <div><b>{item.date}</b></div>
                {(item.startTime && item.endTime) && <div>{`(${item.startTime} - ${item.endTime})`}</div>}
            </div>,
            sorter: (a, b) => sortByDates(a.date.date, b.date.date),
            fixed: 'left'
        },
        {
            title: 'Аудитория',
            dataIndex: 'auditory',
            align: 'center',
            width: 100,
            render: item => <div>{item ? item : ""}</div>,
            fixed: 'left'
        },
        {
            title: 'Объявление',
            dataIndex: 'announcement',
            width: 200,
        },
        ...(scheduleType === 1 ? [{
            title: 'Преподаватель',
            dataIndex: 'employee',
            align: 'center',
            width: 150,
            render: item => <DynamicFilledButton
                text={item.name}
                href={`/schedule/${item.urlId}`}
                onClick={() => localStorage.setItem('employeeUrlId', JSON.stringify(item.urlId))} 
                styles={{ width: 'fit-content', padding: '0 10px', textAlign: 'left' }}/>,
            sorter: (a, b) => a.employee.name.localeCompare(b.employee.name)
        }] : []),
        ...(scheduleType === 2 ? [{
            title: 'Группы',
            dataIndex: 'groups',
            width: 150,
            render: studentGroups => <div>
                {setGroupsList(studentGroups)}
            </div>
        }] : []),
    ]

    const setGroupsList = (groups) => {
        return groups.map((group, index) => <DynamicFilledButton
            key={index}
            text={group.name}
            href={`/schedule/${group.name}`}
            onClick={() => localStorage.setItem('group', JSON.stringify(group.name))} />)
    }

    const setMobileAnnouncemets = () => {
        if (announcements.length > 0)
            return announcements.map((item) =>
                <MobileTableItem
                    data={[
                        <div>
                            <div><b>{item.date}</b></div>
                            {(item.startTime && item.endTime) && <div>{`(${item.startTime} - ${item.endTime})`}</div>}
                        </div>,
                        item.auditory,
                        item.content,
                        <UnderlinedLink
                            text={item.employee}
                            href={`/schedule/${item.urlId}`}
                            onClick={() => localStorage.setItem('employeeUrlId', JSON.stringify(item.urlId))} />,
                        <div className='mt-2'>
                            {setGroupsList(item.studentGroups)}
                        </div>
                    ]}
                    key={item.id}
                    titles={['Дата', 'Аудитория', 'Объявление', 'Преподаватель', 'Группы']}
                />)
        else return <Empty description="Объявлений нет" className='DepartmentInfo_title_color' />
    }

    return loadingAnnouncements
        ? <div>
            {new Array(15).fill(0).map((_, index) => <div className="mb-2" key={index} >
                <Skeleton.Input active block />
            </div>)}
        </div>
        : <React.Fragment>
            <div className={`AnnouncementsModal_container_color ${classes.desktopTable}`}>
                <ConfigProvider renderEmpty={() => <Empty description="Объявлений нет" className='DepartmentInfo_title_color' />}>
                    <Table
                        locale={{
                            triggerDesc: 'Сортировать по убыванию',
                            triggerAsc: 'Сортировать по возрастанию',
                            cancelSort: 'Отключить сортировку'
                        }}
                        sticky
                        pagination={false}
                        columns={columns}
                        scroll={{ x: 900, y: 600 }}
                        dataSource={announcements.map((item, index) => ({
                            key: index,
                            date: { date: item.date, startTime: item.startTime, endTime: item.endTime },
                            announcement: item.content,
                            auditory: item.auditory,
                            employee: { name: item.employee, urlId: item.urlId },
                            groups: item.studentGroups
                        }))} />
                </ConfigProvider>
            </div>
            <div className={classes.mobileTable}>
                {setMobileAnnouncemets()}
            </div>
        </React.Fragment>
}

export default AnnouncementsModal;